import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-set-meta',
  templateUrl: './set-meta.component.html',
  styleUrls: ['./set-meta.component.scss']
})
export class SetMetaComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  seotitle: string;

  @Input()
  image: string;

  @Input()
  text: string;

  @Input()
  seotext: string;

  @Output()
  updated = new EventEmitter();

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit() {
    if (this.title) {
      if (this.seotitle) {
        this.titleService.setTitle(this.seotitle);
      } else {
        this.titleService.setTitle(this.title);
      }
      this.metaService.updateTag({ property: 'og:title', content: this.title });
      this.metaService.updateTag({ property: 'og:url', content: window.location.href });

      this.metaService.updateTag({
        property: 'og:image',
        content: this.image ? this.image : `${environment.baseUrl}/assets/img/ogp.jpg`
      });
    }

    if (this.text && this.text.length > 0) {
      const div = document.createElement('div');
      div.innerHTML = this.text;
      const description = div.textContent.substr(0, 150);
      if (this.seotext) {
        this.metaService.updateTag({ name: 'description', content: this.seotext });
      } else {
        this.metaService.updateTag({ name: 'description', content: description });
      }
      this.metaService.updateTag({ property: 'og:description', content: description });
    } else {
      this.metaService.updateTag({ name: 'description', content: this.title });
      this.metaService.updateTag({ property: 'og:description', content: this.title });
    }

    const script = document.createElement('script');
    script.async = true;

    script.innerHTML = "dataLayer = dataLayer || []; dataLayer.push({'title': '" + document.title + "','event': 'loadready'});";
    script.setAttribute('charset', 'utf-8');

    document.body.appendChild(script);

    this.updated.emit();
  }
}
